import * as types from '../constants/action-types';
import { get } from 'lodash';

const initialState = {
  error: '',
  isFetching: false,
  hasFetched: false,
  invoiceEntriesByBkg: []
};

export default function invoices (state = initialState, action) {
  const { type, data, fetchError } = action;

  switch (type) {
  case types.BKG_INVOICE_ENTRIES_FETCH_REQUEST:
  case types.INVOICE_ENTRIES_BY_TYPE_REQUEST: {
    return { ...state,
      isFetching: true
    }
  }
  // bkgInvoiceEntries: entries are grouped by month
  case types.BKG_INVOICE_ENTRIES_FETCH_SUCCESS: {
    return { ...state,
      isFetching: false,
      hasFetched: true,
      bkgInvoiceEntries: data
    }
  }

  case types.BKG_INVOICE_ENTRIES_FETCH_FAILURE:
  case types.INVOICE_ENTRIES_BY_TYPE_FAILURE: {
    return { ...state,
      isFetching: false,
      hasFetched: true,
      error: fetchError
    }
  }

  case types.INVOICE_ENTRIES_BY_TYPE_SUCCESS: {
    const dataObj = {};
    dataObj[get(data, 'entries[0].txn_type')] = data;

    return { ...state,
      hasFetched: true,
      isFetching: false,
      invoiceEntriesByType: { ...state.invoiceEntriesByType,
        ...dataObj
      }
    }
  }

  default:
    return state;
  }
}
